<template>
  <div class="agreement">
    <div class="title">个体商户注册协议</div>

    <div class="container">
      <!-- <pdf ref="pdf" src="/agree.pdf"></pdf> -->
      <iframe
        :src="latitude?'/wicmp-app-h5/#/serviceAgreementDetails':'/h5-app-sh/#/agreement?aType=user'"
        frameborder="0"
        style="height: 100%; width: 100%"
      ></iframe>
    </div>

    <div class="btn">
      <van-button
        size="large"
        round
        :disabled="seconds > 0"
        color="#FF7D19"
        @click="toRegist"
        >已阅读并同意协议<span v-if="seconds > 0"
          >({{ seconds }}s)</span
        ></van-button
      >
    </div>
  </div>
</template>

<script>
import { Button } from 'vant';
export default {
  components: {
    VanButton: Button,
  },
  computed:{
    latitude(){
      return localStorage.getItem('latitude')
    }
  },
  data() {
    return {
      seconds: 3,
      timer: 0,
    };
  },
  methods: {
    toRegist() {
      this.$router.replace({
        path: '/dq/regist',
        query: { ...this.$route.query },
      });
    },
  },
  mounted() {
    localStorage.removeItem('registInfo');
    localStorage.removeItem('reload');
    if (this.timer) return;
    this.timer = setInterval(() => {
      this.seconds--;
      if (this.seconds <= 0) {
        this.seconds = 0;
        clearTimeout(this.timer);
      }
    }, 1000);

    localStorage.setItem('dq_show', 'true');
  },
  destroyed() {
    clearTimeout(this.timer);
  },
};
</script>

<style lang="less" scoped>
.agreement {
  padding: 0 20px;

  .title {
    font-size: 18px;
    font-weight: 500;
    color: #333333;
  }
  .container {
    height: 75%;
    font-size: 14px;
    font-weight: 400;
    color: #111111;
  }
  .btn {
    position: fixed;
    bottom: 40px;
    left: 20px;
    right: 20px;
    .van-button__text {
      font-size: 18px;
    }
  }
}
</style>